module.exports = __webpack_public_path__ + "static/media/GridBackground.d875ac59.png";